import { Flex, Box } from 'rebass/styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import DynamicTooltip from 'components/atoms/dynamicTooltip';

export const ToolbarButton = ({ option, toolbarOptionChange, active, toolbarCount, tooltip }) => (
  <DynamicTooltip
    useTooltip={Boolean(tooltip)}
    trigger={
      <Flex
        sx={{
          alignItems: 'center',
          gap: '8px',
          p: '8px',
          cursor: 'pointer',
          color: active ? 'text.dark' : 'text.main',
          bg: active ? 'neutral.20' : 'neutral.0',
          borderRadius: '4px',
          width: 'max-content',
          '&:hover': {
            bg: 'neutral.20',
            color: 'text.dark',
          },
        }}
        onClick={() => toolbarOptionChange?.(option.value, option)}
      >
        <Box size="16px" as={option.icon} />
        <Box fontSize="14px" fontWeight="500" lineHeight="16px">
          {option.label}
        </Box>
        {toolbarCount > 0 && (
          <Box
            sx={{
              display: 'flex',
              width: '16px',
              height: '16px',
              padding: '0px 4px',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '99px',
              bg: 'purple.100',
            }}
          >
            <Box sx={{ fontSize: '12px', fontWeight: '600', lineHeight: '16px', color: 'purple.400' }}>
              {toolbarCount}
            </Box>
          </Box>
        )}
      </Flex>
    }
    content={tooltip}
    position="top-end"
    sx={{
      minWidth: 'max-content !important',
      '.tooltip-arrow': { left: '20px !important' },
    }}
  />
);

ToolbarButton.propTypes = {
  option: PropTypes.object.isRequired,
  toolbarOptionChange: PropTypes.func,
  active: PropTypes.bool.isRequired,
  toolbarCount: PropTypes.number,
  tooltip: PropTypes.string,
};

ToolbarButton.defaultProps = {
  toolbarOptionChange: () => {},
  toolbarCount: 0,
  tooltip: '',
};
